export const staticPrimaryColor = '#6366F1'
export const staticPrimaryDarkenColor = '#4F46E5'

const NAVY_BASE = '#0F172A'   // 0dp
const NAVY_1DP = '#16243D'    // +5% overlay (less gray, more navy)
const NAVY_TABLE_SURFACE = '#1A2D4B' // semantic table surface (slightly more saturated)
const NAVY_4DP = '#262D3F'    // +9% overlay
const NAVY_8DP = '#2D3546'    // +12% overlay
const NAVY_16DP = '#353C4D'   // +15% overlay

const TEXT_PRIMARY = '#F8FAFC'
const TEXT_SECONDARY = '#94A3B8'
const SHADOW_CORE = '#020617'

const createNavyColors = () => ({
  'primary': staticPrimaryColor,
  'on-primary': TEXT_PRIMARY,
  'primary-darken-1': staticPrimaryDarkenColor,
  'secondary': staticPrimaryColor,
  'secondary-darken-1': staticPrimaryDarkenColor,
  'on-secondary': TEXT_PRIMARY,
  'success': '#4ADE80',
  'success-darken-1': '#22C55E',
  'on-success': '#052E16',
  'info': '#38BDF8',
  'info-darken-1': '#0EA5E9',
  'on-info': '#082F49',
  'warning': '#FBBF24',
  'warning-darken-1': '#F59E0B',
  'on-warning': '#1F1602',
  'error': '#F87171',
  'error-darken-1': '#EF4444',
  'on-error': '#450A0A',

  'background': NAVY_BASE,
  'on-background': TEXT_PRIMARY,
  'surface': NAVY_1DP,
  'on-surface': TEXT_PRIMARY,
  'surface-variant': NAVY_4DP,
  'on-surface-variant': TEXT_SECONDARY,
  'surface-container-lowest': NAVY_BASE,
  'surface-container-low': NAVY_1DP,
  'surface-container': NAVY_4DP,
  'surface-container-high': NAVY_8DP,
  'surface-container-highest': NAVY_16DP,
  'table-card': NAVY_TABLE_SURFACE,
  'table-toolbar': NAVY_TABLE_SURFACE,

  'grey-50': '#111827',
  'grey-100': '#1F2937',
  'grey-200': '#273449',
  'grey-300': '#334155',
  'grey-400': '#475569',
  'grey-500': '#64748B',
  'grey-600': '#94A3B8',
  'grey-700': '#CBD5E1',
  'grey-800': '#E2E8F0',
  'grey-900': '#F1F5F9',
  'perfect-scrollbar-thumb': '#475569',
  'skin-bordered-background': NAVY_BASE,
  'skin-bordered-surface': NAVY_1DP,
  'expansion-panel-text-custom-bg': NAVY_4DP,
  'track-bg': NAVY_4DP,
  'chat-bg': NAVY_BASE,
  'highlight': '#FBBF24',
  'on-highlight': '#1F1602',
  'status-success': '#4ADE80',
  'status-danger': '#F87171',
  'status-info': '#38BDF8',
  'text-primary': TEXT_PRIMARY,
  'text-secondary': TEXT_SECONDARY,
  'border-subtle': '#475569',
  'bg-base': NAVY_BASE,
  'bg-surface': NAVY_1DP,
})

const createNavyVariables = () => ({
  'code-color': '#FBBF24',
  'overlay-scrim-background': SHADOW_CORE,
  'tooltip-background': NAVY_8DP,
  'overlay-scrim-opacity': 0.6,
  'hover-opacity': 0.06,
  'focus-opacity': 0.1,
  'selected-opacity': 0.08,
  'activated-opacity': 0.16,
  'pressed-opacity': 0.14,
  'dragged-opacity': 0.1,
  'disabled-opacity': 0.4,
  'border-color': '#475569',
  'border-opacity': 0.32,
  'table-header-color': NAVY_4DP,
  'high-emphasis-opacity': 0.95,
  'medium-emphasis-opacity': 0.72,

  // Dark navy shadows (instead of neutral black)
  'shadow-key-umbra-color': SHADOW_CORE,
  'shadow-xs-opacity': '0.40',
  'shadow-sm-opacity': '0.48',
  'shadow-md-opacity': '0.52',
  'shadow-lg-opacity': '0.56',
  'shadow-xl-opacity': '0.60',
})

export const themes = {
  light: {
    dark: false,
    colors: createNavyColors(),
    variables: createNavyVariables(),
  },
  dark: {
    dark: true,
    colors: createNavyColors(),
    variables: createNavyVariables(),
  },
}
export default themes
